import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms14x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms14x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let codapp = ''
    let stdate = ''
    let endate = ''
    if (typeof searchParams !== 'undefined') {
      codapp = (typeof searchParams.codapp !== 'undefined' ? searchParams.codapp : '')
      stdate = (typeof searchParams.dtestrt.replace(/\//g, '') !== 'undefined' ? searchParams.dtestrt.replace(/\//g, '') : '')
      endate = (typeof searchParams.dteend.replace(/\//g, '') !== 'undefined' ? searchParams.dteend.replace(/\//g, '') : '')
      sendParams = {
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codempid_query: (typeof searchParams.codempid3 !== 'undefined' ? searchParams.codempid3 : ''),
        p_staappr: (typeof searchParams.staapprAll !== 'undefined' ? searchParams.staapprAll : 'P')
      }
    }
    return instance().get(endpoint + '/hrms14x/index/' + codapp + '/' + stdate + '/' + endate, { params: sendParams })
  },
  getPopupStatus (popupParams) {
    if (isMock) return generator(mocker.popupStatus())
    let sendParams = {}
    let codapp = ''
    let codempidQuery = ''
    let dtereq = ''
    let numseq = ''
    if (typeof popupParams !== 'undefined') {
      codapp = (typeof popupParams.codapp !== 'undefined' ? popupParams.codapp : '')
      codempidQuery = (typeof popupParams.codempid !== 'undefined' ? popupParams.codempid : '')
      dtereq = (typeof popupParams.dtereq.replace(/\//g, '') !== 'undefined' ? popupParams.dtereq.replace(/\//g, '') : '')
      numseq = (typeof popupParams.numseq !== 'undefined' ? popupParams.numseq : '')
      sendParams = {
        p_routeno: (typeof popupParams.routeno !== 'undefined' ? popupParams.routeno : ''),
        p_approvno: (typeof popupParams.approvno !== 'undefined' ? popupParams.approvno : ''),
        p_typreq: (typeof popupParams.typreq !== 'undefined' ? popupParams.typreq : ''),
        p_dtework: (typeof popupParams.dtework !== 'undefined' ? popupParams.dtework : ''),
        p_codlon: (typeof popupParams.codlon !== 'undefined' ? popupParams.codlon : ''),
        p_codcomp: (typeof popupParams.codcomp !== 'undefined' ? popupParams.codcomp : ''),
        p_codpos: (typeof popupParams.codpos !== 'undefined' ? popupParams.codpos : '')
      }
    }
    return instance().get(endpoint + '/hrms14x/table1popup1/' + codapp + '/' + codempidQuery + '/' + dtereq + '/' + numseq, { params: sendParams })
  },
  getPopupStatusEdit (popupParams) {
    if (isMock) return generator(mocker.popupStatusEdit())
    let searchParams = {
      p_codapp: popupParams.codapp,
      p_codempid_query: popupParams.codempid,
      p_dtereq: popupParams.dtereq.replace(/\//g, ''),
      p_numseq: popupParams.numseq,
      p_approvno: popupParams.approvno
    }
    const params = searchParams.p_codapp + '/' + searchParams.p_codempid_query + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno
    return instance().get(endpoint + '/hrms14x/table1popup1popup1/' + params)
  },
  getPopupRouteNo (popupParams) {
    let searchParams = {
      p_codapp: popupParams.codapp,
      p_codempid_query: popupParams.codempid,
      p_routeno: popupParams.routeno
    }
    if (isMock) return generator(mocker.popupRouteNo())
    const params = searchParams.p_codapp + '/' + searchParams.p_codempid_query + '/' + searchParams.p_routeno
    return instance().get(endpoint + '/hrms14x/table1popup2/' + params)
  },
  postPopupStatusEditSave ({ dataRowsHasFlg }) {
    let params = []
    for (let i = 0; i < dataRowsHasFlg.length; i++) {
      let dataRow = dataRowsHasFlg[i]
      params.push({
        'p_codapp': dataRow.codapp,
        'p_codempid_query': dataRow.codempid_query,
        'p_dtereq': dataRow.dtereq.replace(/\//g, ''),
        'p_numseq': dataRow.numseq,
        'p_approvno': dataRow.approvno,
        'p_seqno': dataRow.seqno,
        'p_codempap': dataRow.codempap,
        'p_codcompap': dataRow.codcompap,
        'p_codposap': dataRow.codposap,
        'p_flg': dataRow.flg
      })
    }
    let saveParams = {
      'param_json': JSON.stringify(params)
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hrms14x/table1popup1popup1save', saveParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms14x/index.js